import React from 'react';

export function TheFooterFunction (props) {
 return (
   <footer className="footer">
   <p>
     &copy; 2024 MajorCompass. All rights reserved: Nobel, Emily, Selma,
     William.
   </p>
 </footer>
 );
}
